import { dew as _keysDew } from "../keys";
import { dew as _validValueDew } from "../valid-value";
var exports = {},
    _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;

  var keys = _keysDew(),
      value = _validValueDew(),
      max = Math.max;

  exports = function (dest, src
  /*, …srcn*/
  ) {
    var error,
        i,
        length = max(arguments.length, 2),
        assign;
    dest = Object(value(dest));

    assign = function (key) {
      try {
        dest[key] = src[key];
      } catch (e) {
        if (!error) error = e;
      }
    };

    for (i = 1; i < length; ++i) {
      src = arguments[i];
      keys(src).forEach(assign);
    }

    if (error !== undefined) throw error;
    return dest;
  };

  return exports;
}